const DashboardWidgets = () => import("Core/configuration/dashboard_widgets/views/DashboardWidgets");
const DashboardWidgetsForm = () => import("Core/configuration/dashboard_widgets/views/DashboardWidgetsForm");

export default {
    children: [
        {
            path: "dashboard_widgets",
            name: "dashboard_widgets",
            component: DashboardWidgets,
            meta: {
                requiresAuth: true,
                title: "lang.dashboard_widgets",
                restrict_by_login_type: [
                    "employee",
                    "customer_support",
                    "administrator",
                    "developer",
                    "csr",
                    "producer",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "customer_readonly",
                    "customer",
                ],
                restrict_by_permission: ["dashboard_widgets.read"],
            },
        },
        {
            path: "dashboard_widget/:id?",
            name: "dashboard_widget",
            component: DashboardWidgetsForm,
            meta: {
                requiresAuth: true,
                title: "lang.dashboard_widgets",
                restrict_by_login_type: [
                    "employee",
                    "customer_support",
                    "administrator",
                    "developer",
                    "csr",
                    "producer",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "customer_readonly",
                    "customer",
                ],
                restrict_by_permission: ["dashboard_widgets.read"],
            },
        },
    ],
};
